<template>
    <nav
        class="navbar primary navbar-expand-lg toolbar-user-nav"
    >
        <div class="container toolbar-user-nav__container">
            <ul class="navbar-nav primary toolbar-user-nav__list">
                <li class="nav-item dropdown">
                    <a
                        class="nav-link dropdown-toggle toolbar-user-trigger"
                        href="javascript:void(0);"
                        id="navbarPrimaryDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        :aria-label="'Menu do utilizador: ' + (userInfoData?.name || 'conta')"
                    >
                        <span class="toolbar-user-avatar" aria-hidden="true">{{ userInitials }}</span>
                    </a>
                    <div
                        class="dropdown-menu"
                        aria-labelledby="navbarPrimaryDropdown"
                    >
                        <div
                            class="menu-header"
                        >
                            <div
                                class="header-icon"
                            >
                                <div
                                    class="icon toolbar-user-avatar toolbar-user-avatar--menu"
                                    aria-hidden="true"
                                >
                                    {{ userInitials }}
                                </div>
                            </div>
                            <div
                                class="header-text"
                            >
                                <div
                                    class="title"
                                >
                                    <h3>
                                        {{ userInfoData?.name?.split(' ')[0] }}
                                    </h3>
                                </div>
                                <div
                                    class="subtitle"
                                >
                                    <h4>
                                        {{ userInfoData?.name?.split(' ')[1] }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div
                            class="menu-content"
                        >
                            <div
                                class="content-link"
                            >
                                <div
                                    class="link"
                                >
                                    <router-link
                                        class="link-content"
                                        to="/configuracoes"
                                        style="cursor: pointer;"
                                    >
                                        Dados da conta
                                    </router-link>
                                </div>
                                <div
                                    class="link"
                                >
                                    <a
                                        class="link-content"
                                        @click="logout"
                                    >
                                        Sair
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </nav>

</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { initialsFromFullName } from '@/utils/userDisplay';

    export default {
        data() {
            return {
                userData: {
                    name: '',
                    email: '',
                    password: ''
                }
            };
        },
        computed: {
            ...mapState(['user', 'userInfoData']),
            userInitials() {
                return initialsFromFullName(this.userInfoData?.name);
            }
        },
        methods: {
            ...mapActions(['storeToken', 'storeRefreshToken']),
            logout() {
                this.storeToken({ token: null });
                this.storeRefreshToken({ refreshToken: null });
                this.$router.push('/');
            }
        }
    }
</script>

<style lang="scss" scoped>
/* Ícone do usuário alinhado à direita e centrado na vertical */
.toolbar-user-nav {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    width: 100% !important;
    left: auto !important;
    transform: none;
    margin: 0;
}

.toolbar-user-nav :deep(.toolbar-user-nav__container) {
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
    width: 100% !important;
    max-width: none !important;
    margin-left: auto;
}

.toolbar-user-nav :deep(.toolbar-user-nav__list) {
    margin-left: auto;
    align-items: center;
}

.toolbar-user-nav :deep(.nav-link) {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.toolbar-user-nav :deep(.nav-link img) {
    display: block;
}

.toolbar-user-trigger {
    padding: 0.15rem !important;
}

.toolbar-user-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    font-size: 0.8125rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #0f1012;
    background: linear-gradient(145deg, #e8eadf 0%, #c5c9bc 100%);
    border: 1px solid rgba(255, 255, 255, 0.12);
    user-select: none;
}

.toolbar-user-avatar--menu {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 0.875rem;
}
</style>

<style scoped>
.loading-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.loading-dots-content {
    display: flex;
    gap: 8px;
}

.dot {
    width: 8px;
    height: 8px;
    background-color: #4FCCEA;
    border-radius: 50%;
    animation: fade 1.5s infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.5s;
}

.dot:nth-child(3) {
    animation-delay: 1s;
}

@keyframes fade {
    0%, 100% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
}

.value-text p {
    color: white;
}

.chat-container {
    height: calc(100vh - 200px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.chat-container::-webkit-scrollbar {
    width: 8px;
}

.chat-container::-webkit-scrollbar-track {
    background: transparent;
}

.chat-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.chat-container::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
